<template>
  <div class="tree-table">
    <table>
<!--      <colgroup>-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--      </colgroup>-->
      <thead>
      <tr>
        <th style="width: 150px;">科目编码</th>
        <th style="width: 150px;">科目名称</th>
        <th style="width: 140px;">单位</th>
        <th style="width: 130px;">数量</th>
        <th style="width: 100px;">单价</th>
        <th style="width: 100px;">金额</th>
        <th style="width: 150px;">备注</th>
<!--        <th>操作</th>-->
      </tr>
      </thead>
      <tbody style="border-left: 1px solid #ddd">
      <tree-row v-for="item in data" :key="item.id" :item="item" :subjectTypeId="subjectTypeId"></tree-row>
      </tbody>
      <tfoot>
      <tr>
        <td>支出小计</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style="text-align: right">{{formattedSpend}}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>税前利润测算</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style="text-align: right">{{formattedProfit}}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import ForecastTreeRow from './forecastTreeRow.vue';
import Decimal from "decimal.js";

export default {
  name: 'TreeTable',
  components: {
    TreeRow: ForecastTreeRow
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    subjectTypeId: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      formattedSpend: 0,
      formattedProfit: 0
    }
  },
  // created() {
  //   this.getSumNum()
  // },
  // mounted() {
  //   this.getSumNum()
  // },
  methods: {
    getSumNum() {
      const validData = this.data.filter(item => item.subjectParentId === '0');
      // 预计算支出和收入总和
      let spendTotal = new Decimal(0);
      let revenueTotal = new Decimal(0);

      validData.forEach(item => {
        const amount = new Decimal(item.beforeAdjustAmount || 0);
        if (item.subjectType === '1') spendTotal = spendTotal.add(amount);
        if (item.subjectType === '0') revenueTotal = revenueTotal.add(amount);
      });
      this.formattedSpend = new Decimal(spendTotal).toFixed(2, Decimal.ROUND_HALF_UP);
      this.formattedProfit = new Decimal(revenueTotal).minus(spendTotal).toFixed(2, Decimal.ROUND_HALF_UP);
    }
  }
};
</script>

<style scoped>
.tree-table {
  width: 100%;
  font-size: 12px;
  overflow-x: auto;
  margin: 20px 0;
}

table {
  width: 920px;
  border-collapse: collapse;
  table-layout: fixed; /* 使表格宽度固定 */
}

th, td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  text-align: center;
}

.child-rows table {
  width: 920px;
  table-layout: fixed;
}
</style>
